// extracted by mini-css-extract-plugin
export default {"wrap":"HH-z","fullWidth":"IH-z","hideOnDesktop":"JH-z","content":"KH-z","hasOpenedNav":"LH-z","crumbsList":"MH-z","dropdownsWrap":"NH-z"};